var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"var(--page-padding)","height":"var(--content-height)"}},[_vm._v(" 控制台 ")])}
var staticRenderFns = []

export { render, staticRenderFns }